import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeGrid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 2,
			width: 4,
			height: 5,
			rx: 1,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.5,
			y: 9,
			width: 4,
			height: 5,
			rx: 1,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.5,
			y: 2,
			width: 7,
			height: 5,
			rx: 1,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 9,
			width: 7,
			height: 5,
			rx: 1,
			stroke: "currentColor"
		})
	]
});
export default SvgHomeGrid;
